import { m as f, h as y, j as m, k as N, p as C, l as P, n as et, I as it } from "./index-CoDGs-6l.js";
import { forwardRef as x, createElement as ct } from "react";
const rt = "_root_1jt2o_12", lt = "_logo_1jt2o_33", g = {
  root: rt,
  logo: lt
}, B = "Bubble";
function S({
  as: t,
  variant: c = "default",
  src: a = "",
  alt: r = "",
  children: e,
  className: o,
  animate: i = !0,
  animationDelay: s = 0,
  style: n,
  ..._
}, l) {
  const p = t || "span", d = i ? f[p] : p, u = y(_) ?? [], E = i ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: s, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ m.jsx(
    d,
    {
      ref: l,
      className: N(
        g.root,
        "airc-ui__" + C(B),
        P(o),
        ...u
      ),
      "data-variant": c,
      ...n ? { style: n } : {},
      ...E,
      ..._,
      children: c === "with-logo" && a && r ? /* @__PURE__ */ m.jsx("img", { className: g.logo, src: a, alt: r }) : e
    }
  );
}
S.displayName = B;
const zt = x(S), mt = "_root_1ncj6_9", _t = "_loader_1ncj6_79", v = {
  root: mt,
  loader: _t
}, k = "Button";
function L({
  as: t,
  children: c,
  className: a,
  variant: r = "default",
  size: e = "medium",
  disabled: o = !1,
  loading: i = !1,
  fullWidth: s = !1,
  animate: n = !0,
  animationDelay: _ = 0,
  href: l,
  target: p,
  rel: d,
  style: u,
  ...E
}, h) {
  const $ = t || (l ? "a" : "button"), M = n ? f[$] : $, nt = y(E) ?? [], at = n ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: _, duration: 0.2 }
  } : {}, st = l ? {
    href: l,
    target: p,
    rel: p === "_blank" ? "noopener noreferrer" : d
  } : {};
  return /* @__PURE__ */ m.jsx(
    M,
    {
      ref: h,
      className: N(
        // The root class from our CSS module
        v.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + C(k),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        P(a),
        ...nt
      ),
      "data-variant": r,
      "data-size": e,
      "data-full-width": s,
      disabled: o || i,
      ...u ? { style: u } : {},
      ...at,
      ...st,
      ...E,
      children: i ? /* @__PURE__ */ m.jsxs("span", { style: { display: "flex", gap: 10 }, children: [
        c,
        /* @__PURE__ */ m.jsx("span", { className: v.loader, "aria-hidden": "true" })
      ] }) : c
    }
  );
}
L.displayName = k;
const It = x(L), pt = "_root_qmf2g_9", dt = {
  root: pt
}, w = "Container", z = x(
  ({ size: t, children: c, className: a, noPadding: r = !1, ...e }, o) => {
    const i = y(e) ?? [];
    return /* @__PURE__ */ m.jsx(
      "div",
      {
        ref: o,
        className: N(
          // The root class from our CSS module
          dt.root,
          // Class purposely exposed to the libray user
          "airc-ui__" + C(w),
          // User's own class(es)
          P(a),
          ...i
        ),
        "data-size": t,
        "data-no-padding": r,
        ...e,
        children: c
      }
    );
  }
);
z.displayName = w;
const ut = z, Nt = "_root_1bt9p_9", yt = {
  root: Nt
}, I = "Emphasized";
function R({
  as: t,
  children: c,
  className: a,
  variant: r = "default",
  animate: e = !0,
  animationDelay: o = 0,
  style: i,
  ...s
}, n) {
  const _ = t || "span", l = e ? f[_] : _, p = y(s) ?? [], d = e ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: o, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ m.jsx(
    l,
    {
      ref: n,
      className: N(
        // The root class from our CSS module
        yt.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + C(I),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        P(a),
        ...p
      ),
      "data-variant": r,
      ...i ? { style: i } : {},
      ...d,
      ...s,
      children: c
    }
  );
}
R.displayName = I;
const Rt = x(
  R
), Ct = "_root_1vkk9_4", Pt = "_imageElement_1vkk9_12", b = {
  root: Ct,
  imageElement: Pt
}, q = "Image";
function K({ as: t, className: c, imageProps: a, fit: r = "cover", ...e }, o) {
  const i = t || "img", s = y(e) ?? [];
  return /* @__PURE__ */ m.jsx(
    "figure",
    {
      ref: o,
      className: N(
        b.root,
        "airc-ui__" + C(q),
        P(c),
        ...s
      ),
      "data-fit": r,
      ...e,
      children: /* @__PURE__ */ m.jsx(
        i,
        {
          ...a,
          className: N(b.imageElement, a == null ? void 0 : a.className)
        }
      )
    }
  );
}
K.displayName = q;
const qt = x(K), xt = "_root_1uoui_12", ft = "_container_1uoui_37", Et = "_iconContainer_1uoui_46", jt = "_content_1uoui_54", j = {
  root: xt,
  container: ft,
  iconContainer: Et,
  content: jt
}, D = "InfoBanner";
function F({
  icon: t,
  as: c,
  children: a,
  className: r,
  variant: e = "info",
  animate: o = !0,
  animationDelay: i = 0,
  style: s,
  ...n
}, _) {
  const l = c || "div", p = o ? f[l] : l, d = y(n) ?? [], u = o ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: i, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ m.jsx(
    p,
    {
      ref: _,
      className: N(
        j.root,
        "airc-ui__" + C(D),
        P(r),
        ...d
      ),
      "data-variant": e,
      ...s ? { style: s } : {},
      ...u,
      ...n,
      children: /* @__PURE__ */ m.jsxs("div", { className: j.container, children: [
        t ? /* @__PURE__ */ m.jsx("div", { className: j.iconContainer, children: et(t) ? typeof t == "function" ? /* @__PURE__ */ m.jsx(t, { className: j.icon }) : (
          // This element would have its props baked-in, if any;
          // it's the responsibility of the library user to style this one.
          t
        ) : /* @__PURE__ */ m.jsx(it, { className: j.icon, icon: t }) }) : null,
        /* @__PURE__ */ m.jsx("div", { className: j.content, children: a })
      ] })
    }
  );
}
F.displayName = D;
const Kt = x(
  F
), $t = "_root_1g5ms_12", ht = "_item_1g5ms_17", T = {
  root: $t,
  item: ht
}, G = "List";
function H({
  items: t,
  as: c,
  className: a,
  animate: r = !0,
  animationDelay: e = 0,
  style: o,
  ...i
}, s) {
  var d;
  const n = c || "ul", _ = r ? f[n] : n, l = y(i) ?? [], p = r ? {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: e, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ m.jsx(
    _,
    {
      ref: s,
      role: n === "div" ? "list" : void 0,
      className: N(
        T.root,
        "airc-ui__" + C(G),
        P(a),
        ...l
      ),
      ...o ? { style: o } : {},
      ...p,
      ...i,
      children: (d = t == null ? void 0 : t.map) == null ? void 0 : d.call(t, (u, E) => {
        const { type: h = n === "ul" ? "li" : "span", content: $, key: M } = u;
        return ct(
          h,
          {
            key: M ?? "listitem__" + E,
            className: T.item,
            role: n === "div" ? "listitem" : void 0
          },
          $
        );
      })
    }
  );
}
H.displayName = G;
const Dt = x(H), Mt = "_root_1mpup_12", Ot = "_spinner_1mpup_26", gt = "_text_1mpup_53", O = {
  root: Mt,
  spinner: Ot,
  text: gt
}, J = "Loader", Q = x(
  ({
    as: t,
    hasText: c = !0,
    text: a = "Caricamento",
    className: r,
    size: e,
    color: o,
    style: i,
    ...s
  }, n) => {
    const _ = t || "div", l = y(s) ?? [], p = {
      ...i,
      ...e && { "--spinner-size": `${e}px` },
      ...o && { "--spinner-color": o }
    };
    return /* @__PURE__ */ m.jsxs(
      _,
      {
        ref: n,
        className: N(
          // The root class from our CSS module
          O.root,
          // Class purposely exposed to the libray user
          "airc-ui__" + C(J),
          // User's own class(es)
          P(r),
          ...l
        ),
        role: "status",
        "aria-label": a,
        style: p,
        ...s,
        children: [
          /* @__PURE__ */ m.jsx("span", { className: O.spinner }),
          c && /* @__PURE__ */ m.jsx("span", { className: O.text, "aria-hidden": "true", children: a })
        ]
      }
    );
  }
);
Q.displayName = J;
const Ft = Q, vt = "_root_1hwp9_9", bt = {
  root: vt
}, U = "Paragraph";
function V({
  as: t,
  children: c,
  className: a,
  alignment: r = "center",
  variant: e = "default",
  animate: o = !0,
  animationDelay: i = 0,
  style: s,
  ...n
}, _) {
  const l = t || "p", p = o ? f[l] : l, d = y(n) ?? [], u = o ? {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { delay: i }
  } : {};
  return /* @__PURE__ */ m.jsx(
    p,
    {
      ref: _,
      className: N(
        // The root class from our CSS module
        bt.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + C(U),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        P(a),
        ...d
      ),
      "data-variant": e,
      "data-alignment": r,
      ...s ? { style: s } : {},
      ...u,
      ...n,
      children: c
    }
  );
}
V.displayName = U;
const Gt = x(
  V
), Tt = "_root_ub753_9", At = {
  root: Tt
}, W = "ProgressStep";
function X({
  as: t,
  active: c = !1,
  className: a,
  animate: r = !0,
  animationDelay: e = 0,
  style: o,
  ariaLabel: i,
  ...s
}, n) {
  const _ = t || "span", l = r ? f[_] : _, p = y(s) ?? [], d = r ? {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
    transition: { delay: e, duration: 0.2 }
  } : {};
  return /* @__PURE__ */ m.jsx(
    l,
    {
      ref: n,
      role: "progressbar",
      "aria-label": i,
      "aria-valuenow": c ? 100 : 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      className: N(
        // The root class from our CSS module
        At.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + C(W),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        P(a),
        ...p
      ),
      "data-active": c,
      ...o ? { style: o } : {},
      ...d,
      ...s
    }
  );
}
X.displayName = W;
const Ht = x(
  X
), Bt = "_root_l51rn_9", A = {
  root: Bt
}, Y = "Section";
function Z({
  as: t,
  bg: c,
  children: a,
  className: r,
  containerStyleProps: e,
  animate: o = !0,
  animationDelay: i = 0,
  style: s,
  ...n
}, _) {
  const l = t || "section", p = o ? f[l] : l, d = y(n) ?? [], u = y(e) ?? [], E = o ? {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { delay: i, duration: 0.3 }
  } : {};
  return /* @__PURE__ */ m.jsx(
    p,
    {
      ref: _,
      className: N(
        A.root,
        "airc-ui__" + C(Y),
        P(r),
        ...d
      ),
      "data-bg": c,
      ...s ? { style: s } : {},
      ...E,
      ...n,
      children: /* @__PURE__ */ m.jsx(
        ut,
        {
          className: N(
            A.wrapper,
            ...u
          ),
          children: a
        }
      )
    }
  );
}
Z.displayName = Y;
const Jt = x(Z), St = "_root_2xe0n_12", kt = {
  root: St
}, tt = "Title";
function ot({
  as: t,
  children: c,
  className: a,
  alignment: r = "center",
  variant: e = "default",
  animate: o = !0,
  animationDelay: i = 0,
  style: s,
  ...n
}, _) {
  const l = t || "h1", p = o ? f[l] : l, d = y(n) ?? [], u = o ? {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { delay: i, duration: 0.3 }
  } : {};
  return /* @__PURE__ */ m.jsx(
    p,
    {
      ref: _,
      className: N(
        // The root class from our CSS module
        kt.root,
        // Class purposely exposed to the libray user
        "airc-ui__" + C(tt),
        // User's own class(es)
        // If the user uses classnames,
        // the result is a string in any case.
        P(a),
        ...d
      ),
      "data-variant": e,
      "data-alignment": r,
      "data-level": t,
      ...s ? { style: s } : {},
      ...u,
      ...n,
      children: c
    }
  );
}
ot.displayName = tt;
const Qt = x(ot);
export {
  zt as B,
  ut as C,
  Rt as E,
  qt as I,
  Dt as L,
  Gt as P,
  Jt as S,
  Qt as T,
  It as a,
  Kt as b,
  Ft as c,
  Ht as d
};
//# sourceMappingURL=index-DqVK32YP.js.map
